import {CLEAN_PRODUCT, LOAD_PRODUCT} from '../actions/types';


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = [], action) => {
    switch (action.type) {
        case LOAD_PRODUCT:
            return action.payload;
        case CLEAN_PRODUCT:
            return action.payload;
        default:
            return state;
    }
};